"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mostrarInfoBlob = exports.redirectToThankYouPage = exports.redirectTo = exports.handleBtnRedireccionValidarDatos = exports.scrollToTop = exports.handleBtnContinuarRedireccion = exports.verificarEstadoValidacionIdentidadRetry = exports.handleBtnReintentarVerificacion = exports.handleBtnEnviar = exports.handleBtnConfirmarPermiso = exports.handleConfirmarDocPosterior = exports.handleReintentarDocPosterior = exports.handlebtnCapturarDocPosterior = exports.handleIniciarCamaraDocPosterior = exports.handleConfirmarDocFrontal = exports.handleReintentarDocFrontal = exports.handlebtnCapturarDocFrontal = exports.handleIniciarCamaraDocFrontal = exports.handleBtnCapturarDocumentos = void 0;
const toggleVisibilidad_1 = require("./toggleVisibilidad");
const domElements_1 = require("./domElements");
const camara_1 = require("./camara");
const appState_1 = require("./appState");
const errors_1 = require("./errors");
const fetchRequests_1 = require("./fetchRequests");
const helpers_1 = require("./helpers");
var getFotoFrontal = appState_1.AppState.getFotoFrontal;
var getFotoPosterior = appState_1.AppState.getFotoPosterior;
const handleBtnCapturarDocumentos = () => {
    console.log('Capturar documentos');
    // toggleVisibilidad(btnCapturarDocumentos, false);
    // toggleVisibilidad(capturePhotoBlock, true);
    (0, exports.handleIniciarCamaraDocFrontal)();
};
exports.handleBtnCapturarDocumentos = handleBtnCapturarDocumentos;
const handleIniciarCamaraDocFrontal = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        console.log('Iniciar cámara documento frontal');
        // Ocultar seccion: Prepárate para tomar las fotos
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.startValidation, false);
        // Se deshabilitan los botones para evitar que se inicien múltiples cámaras
        domElements_1.btnIniciarCamaraDocFrontal.disabled = true;
        domElements_1.btnIniciarCamaraDocPosterior.disabled = true;
        domElements_1.btnEnviar.disabled = true;
        // Se muestra spinner mientras se inicia la cámara
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.capturePhotoBlock, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.spinnerCamara, true);
        // Se inicia la cámara y se muestra el stream en el video
        yield (0, camara_1.iniciarCamara)(domElements_1.videoDocumentoFrontal);
        yield (0, camara_1.mostrarStream)(domElements_1.videoDocumentoFrontal);
        // Se oculta spinner una vez que se ha iniciado la cámara y se muestra la sección para capturar la foto frontal
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionErrorCamara, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.spinnerCamara, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionCapturarFoto, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.capturePhotoBlock, true);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionFotoFrontal, true);
        // Se habilitan los botones
        domElements_1.btnIniciarCamaraDocFrontal.disabled = false;
        domElements_1.btnIniciarCamaraDocPosterior.disabled = false;
        domElements_1.btnEnviar.disabled = false;
    }
    catch (error) {
        if (error instanceof errors_1.CameraPermissionError) {
            domElements_1.textErrorCamara.textContent = 'Habilita el permiso de la cámara para continuar con el proceso';
        }
        else if (error instanceof errors_1.CameraUnavailableError) {
            domElements_1.textErrorCamara.textContent = 'La cámara se encuentra en uso en otra aplicación';
        }
        else {
            domElements_1.textErrorCamara.textContent = 'No se pudo acceder a la cámara';
        }
        // Se habilitan los botones
        domElements_1.btnIniciarCamaraDocFrontal.disabled = false;
        domElements_1.btnIniciarCamaraDocPosterior.disabled = false;
        domElements_1.btnEnviar.disabled = false;
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.spinnerCamara, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionCapturarFoto, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.capturePhotoBlock, true);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionErrorCamara, true);
    }
    finally {
        appState_1.AppState.setCamaraIniciar('frontal');
        window.scrollTo(0, 0);
    }
});
exports.handleIniciarCamaraDocFrontal = handleIniciarCamaraDocFrontal;
const handlebtnCapturarDocFrontal = () => __awaiter(void 0, void 0, void 0, function* () {
    console.log('Capturar foto frontal');
    const foto = yield (0, camara_1.tomarFoto)(domElements_1.videoDocumentoFrontal);
    yield (0, camara_1.detenerCamara)(domElements_1.videoDocumentoFrontal);
    const fotoURL = foto === null || foto === void 0 ? void 0 : foto.fotoURL;
    if (!fotoURL) {
        throw new Error('No se ha podido obtener la foto.');
    }
    domElements_1.imgCapturaDocFrontal.src = fotoURL;
    (0, exports.mostrarInfoBlob)(foto === null || foto === void 0 ? void 0 : foto.blob, domElements_1.detalleImgFrontal);
    appState_1.AppState.setFotoFrontal(fotoURL);
    appState_1.AppState.setFotoFrontalCapturada(true);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionTomarFotoFrontal, false);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionConfirmarFotoFrontal, true);
    window.scrollTo(0, 0);
});
exports.handlebtnCapturarDocFrontal = handlebtnCapturarDocFrontal;
const handleReintentarDocFrontal = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        console.log('Reintentar foto frontal');
        // Evita multiples clics en el botón
        domElements_1.btnReintentarDocFrontal.disabled = true;
        domElements_1.btnConfirmarDocFrontal.disabled = true;
        // Se inicia la cámara y se muestra el stream en el video
        yield (0, camara_1.iniciarCamara)(domElements_1.videoDocumentoFrontal);
        yield (0, camara_1.mostrarStream)(domElements_1.videoDocumentoFrontal);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionConfirmarFotoFrontal, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionTomarFotoFrontal, true);
        // Se habilitan los botones
        domElements_1.btnReintentarDocFrontal.disabled = false;
        domElements_1.btnConfirmarDocFrontal.disabled = false;
        window.scrollTo(0, 0);
    }
    catch (error) {
        if (error instanceof errors_1.CameraPermissionError) {
            domElements_1.textErrorCamara.textContent = 'Habilita el permiso de la cámara para continuar con el proceso';
        }
        else if (error instanceof errors_1.CameraUnavailableError) {
            domElements_1.textErrorCamara.textContent = 'La cámara se encuentra en uso en otra aplicación';
        }
        else {
            domElements_1.textErrorCamara.textContent = 'No se pudo acceder a la cámara';
        }
        // Se habilitan los botones
        domElements_1.btnReintentarDocFrontal.disabled = false;
        domElements_1.btnConfirmarDocFrontal.disabled = false;
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionErrorCamara, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionCapturarFoto, true);
    }
});
exports.handleReintentarDocFrontal = handleReintentarDocFrontal;
// Old flow
/*
export const handleConfirmarDocFrontal = () => {
    console.log('Confirmar foto frontal');

    toggleVisibilidad(seccionFotoFrontal, false);
    toggleVisibilidad(seccionCapturarFoto, true);

    imagenCapturadaFrontal.src = getFotoFrontal() || '';
    previewDocFrontal.classList.add('activo');
    btnIniciarCamaraDocFrontal.classList.add('activo');

    toggleVisibilidad(iconoDocFrontal, true);
    toggleVisibilidad(imagenCapturadaFrontal, true);
    toggleVisibilidad(previewDocFrontal, true);

    setFillColor(previewDocFrontal, 'var(--color-verde-movistar)');
};
*/
// New flow
const handleConfirmarDocFrontal = () => {
    console.log('Confirmar foto frontal');
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionFotoFrontal, false);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionCapturarFoto, true);
    domElements_1.imagenCapturadaFrontal.src = getFotoFrontal() || '';
    domElements_1.previewDocFrontal.classList.add('activo');
    // btnIniciarCamaraDocFrontal.classList.add('activo');
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.iconoDocFrontal, true);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.imagenCapturadaFrontal, true);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.previewDocFrontal, true);
    // setFillColor(previewDocFrontal, 'var(--color-verde-movistar)');
    const isPassport = domElements_1.tipoDocumento.value === 'pasaporte';
    if (isPassport) { // Flujo pasaporte
        // Saltar toma de foto posterior
        console.log('Es pasaporte. Saltar tomar foto posterior');
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionCapturarFoto, true);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.iconoDocPosterior, true);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.imagenCapturadaPosterior, true);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.previewDocPosterior, false);
    }
    else { // Flujo para DUI
        const retryFrontal = domElements_1.btnIniciarCamaraDocFrontal.dataset.retry;
        if (retryFrontal === 'si') {
            console.log('Es reintento frontal: ' + retryFrontal);
            (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionFotoFrontal, false);
            (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionCapturarFoto, true);
        }
        else {
            console.log('Es reintento frontal: ' + retryFrontal + '. Continuar con posterior.');
            (0, exports.handleIniciarCamaraDocPosterior)();
        }
    }
    window.scrollTo(0, 0);
};
exports.handleConfirmarDocFrontal = handleConfirmarDocFrontal;
const handleIniciarCamaraDocPosterior = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        console.log('Iniciar cámara documento posterior');
        // Se deshabilitan los botones para evitar que se inicien múltiples cámaras
        domElements_1.btnIniciarCamaraDocFrontal.disabled = true;
        domElements_1.btnIniciarCamaraDocPosterior.disabled = true;
        domElements_1.btnEnviar.disabled = true;
        // Se muestra spinner mientras se inicia la cámara
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.capturePhotoBlock, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.spinnerCamara, true);
        // Se inicia la cámara y se muestra el stream en el video
        yield (0, camara_1.iniciarCamara)(domElements_1.videoDocumentoPosterior);
        yield (0, camara_1.mostrarStream)(domElements_1.videoDocumentoPosterior);
        // Se oculta spinner una vez que se ha iniciado la cámara y se muestra la sección para capturar la foto posterior
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionErrorCamara, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.spinnerCamara, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionCapturarFoto, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.capturePhotoBlock, true);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionFotoPosterior, true);
        // Se habilitan los botones una vez que se ha iniciado la cámara
        domElements_1.btnIniciarCamaraDocFrontal.disabled = false;
        domElements_1.btnIniciarCamaraDocPosterior.disabled = false;
        domElements_1.btnEnviar.disabled = false;
    }
    catch (error) {
        if (error instanceof errors_1.CameraPermissionError) {
            domElements_1.textErrorCamara.textContent = 'Habilita el permiso de la cámara para continuar con el proceso';
        }
        else if (error instanceof errors_1.CameraUnavailableError) {
            domElements_1.textErrorCamara.textContent = 'La cámara se encuentra en uso en otra aplicación';
        }
        else {
            domElements_1.textErrorCamara.textContent = 'No se pudo acceder a la cámara';
        }
        // Se habilitan los botones
        domElements_1.btnIniciarCamaraDocFrontal.disabled = false;
        domElements_1.btnIniciarCamaraDocPosterior.disabled = false;
        domElements_1.btnEnviar.disabled = false;
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.spinnerCamara, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionCapturarFoto, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.capturePhotoBlock, true);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionErrorCamara, true);
    }
    finally {
        appState_1.AppState.setCamaraIniciar('posterior');
        window.scrollTo(0, 0);
    }
});
exports.handleIniciarCamaraDocPosterior = handleIniciarCamaraDocPosterior;
const handlebtnCapturarDocPosterior = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        console.log('Capturar foto posterior');
        const foto = yield (0, camara_1.tomarFoto)(domElements_1.videoDocumentoPosterior);
        yield (0, camara_1.detenerCamara)(domElements_1.videoDocumentoPosterior);
        const fotoURL = foto === null || foto === void 0 ? void 0 : foto.fotoURL;
        if (!fotoURL) {
            throw new Error('No se ha podido obtener la foto.');
        }
        domElements_1.imgCapturaDocPosterior.src = fotoURL;
        (0, exports.mostrarInfoBlob)(foto === null || foto === void 0 ? void 0 : foto.blob, domElements_1.detalleImgPosterior);
        appState_1.AppState.setFotoPosterior(fotoURL);
        appState_1.AppState.setFotoPosteriorCapturada(true);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionTomarFotoPosterior, false);
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionConfirmarFotoPosterior, true);
        window.scrollTo(0, 0);
    }
    catch (error) {
        if (error instanceof errors_1.CameraPermissionError) {
            domElements_1.textErrorCamara.textContent = 'Habilita el permiso de la cámara para continuar con el proceso';
        }
        else if (error instanceof errors_1.CameraUnavailableError) {
            domElements_1.textErrorCamara.textContent = 'La cámara se encuentra en uso en otra aplicación';
        }
        else {
            domElements_1.textErrorCamara.textContent = 'No se pudo acceder a la cámara';
        }
        (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionErrorCamara, true);
        // @ts-ignore
        console.log('Entra al catch');
    }
});
exports.handlebtnCapturarDocPosterior = handlebtnCapturarDocPosterior;
const handleReintentarDocPosterior = () => __awaiter(void 0, void 0, void 0, function* () {
    console.log('Reintentar foto posterior');
    domElements_1.btnReintentarDocPosterior.disabled = true;
    domElements_1.btnConfirmarDocPosterior.disabled = true;
    yield (0, camara_1.iniciarCamara)(domElements_1.videoDocumentoPosterior);
    yield (0, camara_1.mostrarStream)(domElements_1.videoDocumentoPosterior);
    domElements_1.btnReintentarDocPosterior.disabled = false;
    domElements_1.btnConfirmarDocPosterior.disabled = false;
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionConfirmarFotoPosterior, false);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionTomarFotoPosterior, true);
    window.scrollTo(0, 0);
});
exports.handleReintentarDocPosterior = handleReintentarDocPosterior;
const handleConfirmarDocPosterior = () => {
    console.log('Confirmar foto posterior');
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionFotoPosterior, false);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionCapturarFoto, true);
    domElements_1.imagenCapturadaPosterior.src = getFotoPosterior() || '';
    domElements_1.previewDocPosterior.classList.add('activo');
    // btnIniciarCamaraDocPosterior.classList.add('activo');
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.iconoDocPosterior, true);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.imagenCapturadaPosterior, true);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.previewDocPosterior, true);
    // Asignar si a retry (reintentar frontal) 
    domElements_1.btnIniciarCamaraDocFrontal.dataset.retry = 'si';
    // setFillColor(previewDocPosterior, 'var(--color-verde-movistar)');
    window.scrollTo(0, 0);
};
exports.handleConfirmarDocPosterior = handleConfirmarDocPosterior;
const handleBtnConfirmarPermiso = () => __awaiter(void 0, void 0, void 0, function* () {
    domElements_1.btnConfirmarPermiso.disabled = true;
    if (appState_1.AppState.getCamaraIniciar() === 'frontal') {
        yield (0, exports.handleIniciarCamaraDocFrontal)();
    }
    else {
        yield (0, exports.handleIniciarCamaraDocPosterior)();
    }
    domElements_1.btnConfirmarPermiso.disabled = false;
    window.scrollTo(0, 0);
});
exports.handleBtnConfirmarPermiso = handleBtnConfirmarPermiso;
const verificarEstadoYGuardarDatos = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const responseEstadoValidacion = yield (0, exports.verificarEstadoValidacionIdentidadRetry)(15, 2);
        const datos = {
            uuidUser: domElements_1.uuidUser.value,
            status: responseEstadoValidacion.status
        };
        yield (0, fetchRequests_1.guardarDatosValidacionIdentidad)(datos);
        return responseEstadoValidacion;
    }
    catch (error) {
        const datos = {
            uuidUser: domElements_1.uuidUser.value,
            status: 'error'
        };
        yield (0, fetchRequests_1.guardarDatosValidacionIdentidad)(datos);
        throw error;
    }
});
const handleBtnEnviar = () => __awaiter(void 0, void 0, void 0, function* () {
    // Desplazarse hacia arriba
    (0, exports.scrollToTop)();
    try {
        domElements_1.btnEnviar.disabled = true;
        if (domElements_1.btnProcessing) {
            domElements_1.btnEnviar.classList.add('d-none');
            domElements_1.btnProcessing.classList.remove('d-none');
        }
        let isValid = false;
        const isPassport = domElements_1.tipoDocumento.value === 'pasaporte';
        if (isPassport) { // Flujo pasaporte
            isValid = !appState_1.AppState.getFotoFrontal();
        }
        else { // Flujo para DUI
            isValid = !appState_1.AppState.getFotoFrontal() || !appState_1.AppState.getFotoPosterior();
        }
        // Se valida que se hayan capturado las fotos
        if (isValid) {
            // toggleVisibilidad(errorGeneral, true);
            // handleBtnRedireccionThankYouPage();
            (0, exports.redirectToThankYouPage)();
            return;
        }
        else {
            (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.errorGeneral, false);
        }
        console.log(domElements_1.seccionVerificarIdentidad);
        console.log(domElements_1.uuidUser);
        console.log(domElements_1.uuidUser.value);
        console.log(domElements_1.tipoDocumento.value);
        // toggleVisibilidad(seccionVerificarIdentidad, false);
        // toggleVisibilidad(spinnerVerificacion, true);
        const datos = {
            uuidUser: domElements_1.uuidUser.value,
            documento: domElements_1.tipoDocumento.value,
            fotoDocFrontal: appState_1.AppState.getFotoFrontal(),
            fotoDocPosterior: isPassport ? null : appState_1.AppState.getFotoPosterior(),
            fechaHoraInicioString: '2023-05-25T14:45:48.742+0000'
        };
        const responseIniciarValidacion = yield (0, fetchRequests_1.iniciarValidacionIdentidad)(datos);
        if (responseIniciarValidacion.status !== 'success') {
            console.log('Error al iniciar la validación de identidad', responseIniciarValidacion);
            // toggleVisibilidad(seccionMensajeError, true);
            //  handleBtnRedireccionThankYouPage();
            (0, exports.redirectToThankYouPage)();
            return;
        }
        console.log(responseIniciarValidacion.data.urlRedirect);
        // Redireccion a pagina validar datos
        (0, exports.redirectTo)(responseIniciarValidacion.data.urlRedirect);
        /*
        const responseVerificarEstadoYGuardarDatos = await verificarEstadoYGuardarDatos();

        if (responseVerificarEstadoYGuardarDatos.status !== 'success') {
            console.log('Error al verificar el estado de la validación', responseVerificarEstadoYGuardarDatos);
            toggleVisibilidad(seccionMensajeError, true);
            //  handleBtnRedireccionThankYouPage();
            return;
        }

        const responseDatosValidacion = await obtenerDatosValidacionIdentidad();

        if (responseDatosValidacion.status !== 'success') {
            console.log('Error al obtener los datos de validación', responseDatosValidacion);
            toggleVisibilidad(seccionMensajeError, true);
            //  handleBtnRedireccionThankYouPage();
            return;
        }

        textNombreCliente.textContent = responseDatosValidacion.data.nombre;

        toggleVisibilidad(seccionMensajeExito, true);
        */
        domElements_1.btnEnviar.disabled = false;
        if (domElements_1.btnProcessing) {
            domElements_1.btnEnviar.classList.remove('d-none');
            domElements_1.btnProcessing.classList.add('d-none');
        }
    }
    catch (error) {
        console.log('Error en el proceso de validación de identidad', error);
        // toggleVisibilidad(seccionMensajeError, true);
        //  handleBtnRedireccionThankYouPage();
        (0, exports.redirectToThankYouPage)();
    }
});
exports.handleBtnEnviar = handleBtnEnviar;
const handleBtnReintentarVerificacion = () => {
    domElements_1.imagenCapturadaFrontal.src = '';
    domElements_1.imagenCapturadaPosterior.src = '';
    domElements_1.imgCapturaDocPosterior.src = '';
    domElements_1.imgCapturaDocFrontal.src = '';
    domElements_1.previewDocFrontal.classList.remove('activo');
    domElements_1.btnIniciarCamaraDocFrontal.classList.remove('activo');
    domElements_1.previewDocPosterior.classList.remove('activo');
    domElements_1.btnIniciarCamaraDocPosterior.classList.remove('activo');
    (0, helpers_1.setFillColor)(domElements_1.previewDocFrontal, '#D3D4D3');
    (0, helpers_1.setFillColor)(domElements_1.previewDocPosterior, '#D3D4D3');
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.iconoDocFrontal, false);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.iconoDocPosterior, false);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.imagenCapturadaFrontal, false);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.imagenCapturadaPosterior, false);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionConfirmarFotoFrontal, false);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionConfirmarFotoPosterior, false);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionTomarFotoFrontal, true);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionTomarFotoPosterior, true);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionMensajeError, false);
    (0, toggleVisibilidad_1.toggleVisibilidad)(domElements_1.seccionVerificarIdentidad, true);
    appState_1.AppState.reset();
};
exports.handleBtnReintentarVerificacion = handleBtnReintentarVerificacion;
const verificarEstadoValidacionIdentidadRetry = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (maxRetries = 5, delay = 2) {
    let retries = 0;
    let response;
    do {
        response = yield (0, fetchRequests_1.verificarEstadoValidacionIdentidad)();
        retries++;
        if (response.status === 'success' || response.status === 'error') {
            break;
        }
        yield new Promise(resolve => setTimeout(resolve, delay * 1000));
    } while (retries < maxRetries);
    return response;
});
exports.verificarEstadoValidacionIdentidadRetry = verificarEstadoValidacionIdentidadRetry;
const handleBtnContinuarRedireccion = () => {
    // Obtener el parámetro "redirect" de la URL
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const redirectParam = urlParams.get('redirect');
    // Decodificar de base64 el parámetro "redirect"
    if (redirectParam) {
        try {
            let decodedUrl = atob(redirectParam);
            decodedUrl = decodeURIComponent(decodedUrl);
            window.location.href = decodedUrl;
        }
        catch (error) {
            window.location.href = '/';
        }
    }
    else {
        // Si no existe, se redirecciona al home
        window.location.href = '/';
    }
};
exports.handleBtnContinuarRedireccion = handleBtnContinuarRedireccion;
// unción de desplazamiento hacia arriba
const scrollToTop = () => {
    console.log('up');
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};
exports.scrollToTop = scrollToTop;
const handleBtnRedireccionValidarDatos = (urlRedirect) => {
    if (urlRedirect) {
        window.location.href = urlRedirect;
    }
    else {
        // Si no existe, se redirecciona al home
        window.location.href = '/';
    }
};
exports.handleBtnRedireccionValidarDatos = handleBtnRedireccionValidarDatos;
/**
 * Redirecciona a una URL o al home si no se proporciona una válida
 * @param {string} [url] - URL de destino (opcional)
 */
const redirectTo = (url) => {
    window.location.href = (url === null || url === void 0 ? void 0 : url.trim()) || '/';
};
exports.redirectTo = redirectTo;
/**
 * Redirecciona a la URL especificada en el input o al home por defecto
 * @returns {void}
 */
const redirectToThankYouPage = () => {
    var _a;
    const targetUrl = (_a = domElements_1.urlThankYouPage === null || domElements_1.urlThankYouPage === void 0 ? void 0 : domElements_1.urlThankYouPage.value) === null || _a === void 0 ? void 0 : _a.trim();
    window.location.href = targetUrl || '/';
};
exports.redirectToThankYouPage = redirectToThankYouPage;
/**
 * Extrae información de un Blob
 * @param {Blob} imageBlob - El objeto blob de la imagen.
 * @param {object} element - El ID del elemento donde mostrar el texto.
 */
const mostrarInfoBlob = (imageBlob, element) => {
    if (!imageBlob || !element)
        return;
    // 1. Calcular Peso
    const sizeInKB = (imageBlob.size / 1024).toFixed(2);
    // 2. Obtener Formato
    let extension = imageBlob.type.split('/')[1] || 'file';
    // 3. Asignar al elemento con el formato solicitado: .ext 00.00kb
    element.textContent = `.${extension} ${sizeInKB}kb`;
};
exports.mostrarInfoBlob = mostrarInfoBlob;
